import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import useCommonStore from 'www/vue_components/common/TheFilters/doctors/stores/useCommonStore'

function replaceMetaRobots() {
  const filtersStore = useFiltersStore()
  const commonStore = useCommonStore()

  if (commonStore.doctorList.isSeoEnabled) {
    return
  }

  const content = filtersStore.filters.place ? 'noindex, nofollow' : 'all'

  const metaNode = document.querySelector('[name="robots"]')

  if (metaNode) {
    metaNode.setAttribute('content', content)
  } else {
    const metaNodeCreated = document.createElement('meta')

    metaNodeCreated.setAttribute('name', 'robots')
    metaNodeCreated.setAttribute('content', content)

    document.head.append(metaNodeCreated)
  }
}

export default replaceMetaRobots
